import { useEffect, useState } from "react"
import { useLocation, useNavigate } from 'react-router-dom'
import { AddPackageToUserRequest } from "../core/_requests"
import Swal from 'sweetalert2';
import { detect } from 'detect-browser';
import { useTranslation } from "react-i18next";

const CheckPackagePayment = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [message, setMessage] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [statusMessage, setStatusessage] = useState('');
    const [refId, setRefId] = useState('');
    const browser = detect();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const authority = params.get('Authority') ?? '';
        const status = params.get('Status') ?? '';

        if (authority == '') {
            setMessage(t('PAYMENT.PAYMENT_PROBLEM'))
            setShowMessage(true)
            setStatusessage('error')
        }
        else {
            addPackageToUser(authority)
        }
    }, [location.search, t])


    const swalWithRedirect = Swal.mixin({
        didClose: () => {
            if (browser && browser.os) {
                if (browser.os.includes('Android')) {
                    const appUrlScheme = 'airngin://www.airngin.com';
                    window.location.href = appUrlScheme;
                } else if (browser.os.includes('Windows')) {
                    navigate('/payment/chargeWallet')
                } else {

                }
            } else {

            }
        }
    });


    useEffect(() => {
        if (showMessage == true) {
            if (statusMessage == 'error') {
                showErrorSwal()
            }
            else if (statusMessage == 'success') {
                showSwal()
            }
        }
    }, [showMessage])

    const showSwal = () => {
        swalWithRedirect.fire({
            title: t('PAYMENT.SUCCESS_TITLE'),
            text: t('PAYMENT.TRANSACTION_NUMBER', { refId }),
            icon: 'success',
            confirmButtonText: t('AUTH.REGISTER_LOGIN.OK')
        });
    }

    const showErrorSwal = () => {
        swalWithRedirect.fire({
            title: message,
            icon: 'error',
            confirmButtonText: t('AUTH.REGISTER_LOGIN.OK')
        });
    }

    const addPackageToUser = async (authority) => {
        var addPackageToUserRequestResult = await AddPackageToUserRequest(authority)
        if (addPackageToUserRequestResult.data?.isSuccess == true) {
            if (addPackageToUserRequestResult.data?.data.returnCode == 100 || addPackageToUserRequestResult.data?.data.returnCode == 100) {
                setRefId(addPackageToUserRequestResult.data?.data.ref_Id)
                setShowMessage(true)
                setStatusessage('success')
            }
            else {
                setMessage(addPackageToUserRequestResult.data?.data.message)
                setShowMessage(true)
                setStatusessage('error')
            }
        }
        else if (addPackageToUserRequestResult.data?.isSuccess == false) {
            if (addPackageToUserRequestResult.data?.data.message != '') {
                setMessage(addPackageToUserRequestResult.data?.data.message)
                setShowMessage(true)
                setStatusessage('error')
            }
            else {
                let message = JSON.parse(addPackageToUserRequestResult.data.message);
                if (message.length >= 1) {
                    let messageShow = message[0].Value.DefaultMessage
                    if (addPackageToUserRequestResult.data.requestId != null) {
                        messageShow = messageShow + '\n ' + t('AUTH.VERIFY.ERROR_CODE') + ' : ' + addPackageToUserRequestResult.data.requestId
                    }
                    //warning
                    if (addPackageToUserRequestResult.data.returnType == 2) {
                        setMessage(messageShow)
                        setShowMessage(true)
                        setStatusessage('error')
                    }
                    //error
                    else if (addPackageToUserRequestResult.data.returnType == 3) {
                        setMessage(messageShow)
                        setShowMessage(true)
                        setStatusessage('error')
                    }
                }
                else {
                    let messageShow = message.Value.DefaultMessage
                    if (addPackageToUserRequestResult.data.requestId != null) {
                        messageShow = messageShow + '\n ' + t('AUTH.VERIFY.ERROR_CODE') + ' : ' + addPackageToUserRequestResult.data.requestId
                    }
                    //warning
                    if (addPackageToUserRequestResult.data.returnType == 2) {
                        setMessage(messageShow)
                        setShowMessage(true)
                        setStatusessage('error')
                    }
                    //error
                    else if (addPackageToUserRequestResult.data.returnType == 3) {
                        setMessage(messageShow)
                        setShowMessage(true)
                        setStatusessage('error')
                    }
                }
            }
        }
        else {
            setMessage(`${t('PAYMENT.STATUS_FETCH_ERROR')} : \n ${addPackageToUserRequestResult}`)
            setShowMessage(true)
            setStatusessage('error')
        }
    }

    return(
        <div className='card mb-5 mb-xl-8'>


        </div>
    )
}

export { CheckPackagePayment }
